module.exports = __webpack_public_path__ + "img/swipe1.png";